var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscentchatLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.363 9.58176C5.57825 9.58176 5.75991e-07 14.2475 5.75991e-07 19.9827C5.75991e-07 22.2753 0.88922 24.6052 2.51994 26.411L0.217149 29.0426C0.105973 29.1696 0.0338023 29.326 0.00929526 29.493C-0.0152117 29.66 0.00898584 29.8305 0.078985 29.9841C0.14863 30.1379 0.261122 30.2684 0.402992 30.3598C0.544862 30.4513 0.710096 30.5 0.878908 30.5H13.2419C18.2514 30.5 24.726 26.1862 24.726 19.9827C24.726 14.2475 19.1478 9.58176 12.363 9.58176ZM7.03108 21.5937C6.06206 21.5937 5.27333 20.8049 5.27333 19.8359C5.27333 18.8669 6.06212 18.0782 7.03108 18.0782C8.00005 18.0782 8.78884 18.867 8.78884 19.8359C8.7889 20.8049 8.00011 21.5937 7.03108 21.5937ZM12.363 21.5937C11.394 21.5937 10.6052 20.8049 10.6052 19.8359C10.6052 18.8669 11.394 18.0782 12.363 18.0782C13.332 18.0782 14.1208 18.867 14.1208 19.8359C14.1208 20.8049 13.332 21.5937 12.363 21.5937ZM17.6949 21.5937C16.7259 21.5937 15.9372 20.8049 15.9372 19.8359C15.9372 18.8669 16.726 18.0782 17.6949 18.0782C18.6639 18.0782 19.4527 18.867 19.4527 19.8359C19.4527 20.8049 18.6639 21.5937 17.6949 21.5937Z",
    fill: "url(#paint0_linear_1053_17166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7873 18.3845L27.718 15.9701C29.1951 14.3033 29.9994 12.2707 29.9994 10.1679C29.9993 4.83703 24.8737 0.5 18.5738 0.5C12.877 0.5 8.03714 4.05021 7.18255 8.67107C8.77208 8.13095 10.5547 7.82391 12.3631 7.82391C20.0595 7.82391 26.3829 13.1997 26.4753 19.8359H29.1205C29.8712 19.8359 30.2744 18.9519 29.7873 18.3845Z",
    fill: "url(#paint1_linear_1053_17166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1053_17166",
    x1: 15,
    y1: 0.5,
    x2: 15,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1053_17166",
    x1: 15,
    y1: 0.5,
    x2: 15,
    y2: 30.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscentchatLogin);
export default __webpack_public_path__ + "static/media/ascentchatLogin.1726f9b16137cf0f7770e99522fad488.svg";
export { ForwardRef as ReactComponent };